import { UpdateResultLabelConceptMappingDocument } from 'generated/resources/graphql'
import type { UpdateResultLabelConceptMappingMutationVariables } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useUpdateResultLabelConceptMapping = () => {
  const [updateResultLabelConceptMapping, { loading }] = useMutation(
    UpdateResultLabelConceptMappingDocument,
    {
      extractorFn: (data) => data.payrollMutations.updatePayrollResultLabelConceptMapping,
    }
  )

  return {
    loading,
    update({ id, conceptId }: UpdateResultLabelConceptMappingMutationVariables) {
      return updateResultLabelConceptMapping({
        variables: { id, conceptId },
      })
    },
  }
}

export default useUpdateResultLabelConceptMapping
